import React from 'react';
import { BookOpenCheckIcon, CalendarDaysIcon, CheckIcon, ClipboardListIcon, DumbbellIcon } from 'lucide-react';
const stats = [[BookOpenCheckIcon, '460+', 'Pagine tecniche'], [ClipboardListIcon, '360+', 'Sessioni pronte all’uso'], [DumbbellIcon, '120+', 'Esercizi per Under 10'], [CalendarDaysIcon, '6', 'Volumi completi']];
const tags = ['Mini-Tennis Elite · Rosso, Arancione, Verde', 'Perfezionamento Tecnico · 11–16 anni', 'Tennis Adulti e Gruppi Sociali', 'Metodo Agonistico e Tornei', 'Preparazione Fisica Integrata', 'Business e Gestione della Scuola'];
export function SystemSection() {
  return <section className="border-y-4 border-emerald-400 bg-[#1b2b1e] px-5 py-20" data-id="element-240" data-mp="2ssnd96quii9e">
      <div className="mx-auto max-w-6xl text-center" data-id="element-241" data-mp="2nulsmhdruavt">
        <p className="inline-block bg-emerald-400 px-4 py-2 text-xs font-bold uppercase tracking-widest text-[#102016]" data-id="element-242" data-mp="2ity545or4c6c">
          Il sistema più completo per i Maestri di Tennis
        </p>
        <h2 className="mt-7 font-display text-5xl font-bold uppercase leading-none text-white sm:text-7xl" data-id="element-243" data-mp="13z7xxakdwoqg">
          TENNIS <span className="text-emerald-300" data-id="element-244" data-mp="18pof95rbsui3">PRONTO</span>
        </h2>
        <p className="mx-auto mt-6 max-w-2xl text-base font-medium leading-relaxed text-slate-300" data-id="element-245" data-mp="18rrbw8mzhlvs">
          Oltre 460 pagine di piani di lezione, drills professionali, schede
          tecniche e guide business per la tua scuola —{' '}
          <strong className="text-white" data-id="element-246" data-mp="1mpfx5hkyqv1d">tutto già fatto per te.</strong>
        </p>
        <div className="mt-11 grid grid-cols-2 gap-3 lg:grid-cols-4" data-id="element-247" data-mp="1roiq43no5asz">
          {stats.map(([Icon, value, label]) => <div key={label} className="border border-emerald-300/25 bg-[#101a12] p-6" data-id="element-248" data-mp="1csbbdiv151l3">
              <Icon className="mx-auto h-7 w-7 text-emerald-300" data-id="element-249" data-mp="1hp1pw1r6rp4e" />
              <p className="mt-4 font-display text-4xl font-bold text-white" data-id="element-250" data-mp="1c3bjp6zg4d4">
                {value}
              </p>
              <p className="text-xs font-bold uppercase tracking-widest text-slate-300" data-id="element-251" data-mp="6c918ztozgsk">
                {label}
              </p>
            </div>)}
        </div>
        <div className="mt-4 border border-emerald-300/25 bg-[#101a12] p-7" data-id="element-252" data-mp="23yrwf25anrkj">
          <p className="text-xs font-bold uppercase tracking-[.2em] text-white" data-id="element-253" data-mp="1z81szugfhysh">
            Copertura completa per ogni ora di lezione
          </p>
          <div className="mt-5 flex flex-wrap justify-center gap-2" data-id="element-254" data-mp="1u8p659pk4rpw">
            {tags.map(tag => <span key={tag} className="flex items-center gap-1.5 border border-emerald-300/25 bg-[#1b2b1e] px-3 py-2 text-xs font-bold text-white" data-id="element-255" data-mp="1pboxcr1bpav3">
                <CheckIcon className="h-3.5 w-3.5 text-emerald-300" data-id="element-256" data-mp="1g9z73oj6ghyw" />
                {tag}
              </span>)}
          </div>
        </div>
      </div>
    </section>;
}